import { Text } from 'govwell-ui'

import AIPageContainer from 'src/components/AIAssistant/AIPageContainer'
import { useMyOrg } from 'src/layouts/AppStateContextLayout/utils'
import AIAssistantChatWindow from 'src/pages/AIChat/AIAssistantChatWindow'

const AIAssistantTestPage = () => {
  const org = useMyOrg()
  const slug = org?.slug ?? ''
  const hasCommunityAssistantQuota = typeof org?.aiCommunityAssistantMonthlyQuota === 'number'

  return (
    <AIPageContainer
      title="Test Community Assistant"
      subtitle="See how your Community Assistant will respond to users"
    >
      <Text.BodySmall>
        Chats on this page will not appear in your Community Assistant history or analytics
        {hasCommunityAssistantQuota ? ', and will not be counted toward your usage quota' : ''}.
      </Text.BodySmall>
      <AIAssistantChatWindow orgSlug={slug} isExpanded={true} showHeader />
    </AIPageContainer>
  )
}

export default AIAssistantTestPage
